<template>
    <div>
      <h2>Tentang Kami</h2>
      <p>Ini adalah halaman tentang kami.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HalamanAbout',
  };
  </script>
  